import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-07-10
 * @brief SEI 에너지컨설팅 개발
 *
 ********************************************************************/
import { useState } from "react";
// recoil
import { useRecoilValue } from "recoil";
import { curConsultingState } from "../../../recoil/assessmentState";
// utils
import ConsultingHeader from "./ConsultingHeader";
import ConsultingView from "./ConsultingView";
function ConsultingMain() {
    const recoilTreeData = useRecoilValue(curConsultingState);
    const [nodata, setNodata] = useState(0);
    const [chenageZone, setChangeZone] = useState(null);
    const [etype, setEtype] = useState(1);
    const [sType, setStype] = useState(1);
    const [etypeB, setEtypeB] = useState(false);
    const [sTypeB, setStypeB] = useState(false);
    // 최상단 이동
    function ScrollTops(e) {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
    return (_jsx(_Fragment, { children: _jsxs("main", Object.assign({ className: "container wide" }, { children: [_jsx("section", Object.assign({ className: "content" }, { children: _jsxs("article", Object.assign({ className: "box" }, { children: [_jsx(ConsultingHeader, { setChangeZone: setChangeZone, setEtype: setEtype, setStype: setStype, setEtypeB: setEtypeB, setStypeB: setStypeB }), _jsx("div", Object.assign({ className: "box__body" }, { children: recoilTreeData.zoneId && (_jsx(ConsultingView, { setNodata: setNodata, etype: etype, setEtype: setEtype, sType: sType, setStype: setStype, chenageZone: chenageZone, etypeB: etypeB, setEtypeB: setEtypeB, sTypeB: sTypeB, setStypeB: setStypeB })) }))] })) })), nodata > 0 && (_jsx("button", Object.assign({ type: "button", className: "btn-top", onClick: (e) => ScrollTops(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD654\uBA74 \uC704\uB85C \uC774\uB3D9" })) })))] })) }));
}
export default ConsultingMain;
